import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import TermsOfUseCheckbox from "../components/TermsOfUseCheckbox";
import TermsAndConditionsCheckbox from "../components/TermsAndConditionsCheckbox";
import FormHOC from "./FormHOC";
import Button from "../elements/Button";
import { NETWORK_TELSTRA, SERVICE_MOBILE } from "../constants";
import ComparePlans from "../components/ComparePlans/ComparePlans";
import globals from "../globals";
import MobilePlanAdditionalText from "../components/MobilePlanAdditionalText";
import MobilePlanAdditionalData from "../components/MobilePlanAdditionalData";
import ReactModal from "../modules/ReactModal";
import CustomLink from "../components/CustomLink";

const options = {
    postUrl: "/api/postRechargeMobile",
    success:
        "Your recharge was successful and will be applied to your mobile within the next two minutes."
};
const state = {
    serviceId: null,
    planId: null,
    existingPlanId: null,
    termsOfUse: false,
    termsAndConditions: false
};

const RechargeMobileForm = props => {
    const [showWarning, setShowWarning] = useState(false);

    useEffect(
        () => {
            props.setDynamicValues({
                serviceId: props.serviceId,
                planId: props.values.planId
                    ? props.values.planId
                    : props.existingPlanId,
                existingPlanId: props.existingPlanId
            });
        },
        [props.serviceId]
    );

    const handleChangePlan = id => {
        props.setDynamicValues({
            planId: id
        });
    };

    const handleSubmit = event => {
        event.preventDefault();
        if (
            props.values.planId !== props.existingPlanId &&
            (props.existingPlanId === 413 || props.existingPlanId === 414)
        ) {
            setShowWarning(true);
        } else {
            props.handleSubmit();
        }
    };

    const handleHideModal = event => {
        if (event) {
            event.preventDefault();
        }
        setShowWarning(false);
    };

    const mapExistingPlanFields = () => {
        return {
            title: "",
            data: "",
            dataAdditional: "",
            price: "",
            features: []
        };
    };

    const mapApiPlanFields = () => {
        const plans = [];

        props.plans.forEach(plan => {
            const additionalText1 =
                plan.features.length >= 3 ? (
                    <MobilePlanAdditionalText
                        content={[plan.features[1], plan.features[2]]}
                    />
                ) : (
                    ""
                );
            const additionalText2 =
                plan.features.length >= 4 ? (
                    <MobilePlanAdditionalText
                        content={plan.features[3] ? [plan.features[3]] : []}
                    />
                ) : (
                    ""
                );

            plans.push({
                id: plan.id,
                title: plan.title,
                data: <span className="bold">{plan.data}</span>,
                dataAdditional: (
                    <MobilePlanAdditionalData content={plan.dataAdditional} />
                ),
                special: plan.special ? plan.special : null,
                price: plan.price,
                features: plan.features[0] ? [plan.features[0]] : [],
                additionalText1: additionalText1,
                additionalText2: additionalText2,
                costPerGb: plan.costPerGb,
            });
        });

        return plans;
    };

    return (
        <React.Fragment>
            <ReactModal
                showModal={showWarning}
                handleCloseModal={handleHideModal}
            >
                <div className="row">
                    <div className="col-12 col-lg-8 offset-lg-2 text-center">
                        <p className="mt-0 mt-3 mt-lg-0 mb-4 lh bold">
                            IMPORTANT : Changing recharge plan will result in
                            the permanent loss of the additional bonus data you
                            currently receive on this plan each recharge cycle.
                            <br />
                            <br />
                            Do you wish to continue?
                        </p>
                        <div className="d-flex justify-content-center">
                            <Button
                                title="Confirm"
                                action={props.handleSubmit}
                                className="mr-3"
                            />
                            <Button
                                title="Cancel"
                                action={handleHideModal}
                                color="red"
                            />
                        </div>
                    </div>
                </div>
            </ReactModal>
            <div className="recharge-mobile-form">
                <div className="row mb-4">
                    <div className="col-12 px-2 px-lg-4">
                        <div className="text-center">
                            <h2
                                className="m-0 mb-2"
                                dangerouslySetInnerHTML={{
                                    __html: globals.noWidows(
                                        "Choose your auto-recharge plan below"
                                    )
                                }}
                            />
                            <p className="m-0 mb-4">
                                You will immediately start a new allowance cycle
                                and the plan you select will auto-recharge every
                                30 days.
                            </p>
                        </div>
                        <ComparePlans
                            type={SERVICE_MOBILE}
                            mobileNetwork={NETWORK_TELSTRA}
                            plans={mapApiPlanFields()}
                            existingPlan={mapExistingPlanFields()}
                            handleSelect={handleChangePlan}
                            selectedPlanId={props.values.planId}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 col-md-8 offset-md-2">
                        <TermsOfUseCheckbox
                            errors={props.errors}
                            value={props.values.termsOfUse}
                            handleClick={value =>
                                props.setDynamicValues({ termsOfUse: value })
                            }
                            cisUrl="https://files.exetel.com.au/cis/mobile/2025-01-23/Exetel_Prepaid_Mobile_CIS.pdf"
                            termsUrl="https://files.exetel.com.au/terms/ExetelAcceptableTelstraMobileUsePolicy.pdf"
                        />
                        <br />
                        <TermsAndConditionsCheckbox
                            errors={props.errors}
                            value={props.values.termsAndConditions}
                            handleClick={value =>
                                props.setDynamicValues({
                                    termsAndConditions: value
                                })
                            }
                            type={SERVICE_MOBILE}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 col-md-8 offset-md-2">
                        {props.children}
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-12 my-2 col-md-4 offset-md-2 text-center text-md-left">
                        <Button title="Recharge now" action={handleSubmit} />
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

RechargeMobileForm.propTypes = {
    serviceId: PropTypes.number.isRequired,
    plans: PropTypes.array.isRequired,
    existingPlanId: PropTypes.number.isRequired
};

export default FormHOC(RechargeMobileForm, state, options);



// WEBPACK FOOTER //
// ./resources/js/forms/RechargeMobileForm.js